import { isSupportedProviderDestination, type CourseIntegrationReadiness, type IntegrationCapabilityReadiness } from "@/lib/api/integrations";
import { FRAME_COPY } from "./course-frame-copy";
import { isReady } from "./course-readiness";

/* ------------------------------------------------------------------ */
/* C04: the course connections                                         */
/* ------------------------------------------------------------------ */

const FAMILY_OWNER: Record<string, string> = {
  "google.classroom": "Google Classroom",
  "google.drive": "Google Drive",
  zoom: "Zoom",
};

/** The provider pages that repair one capability on the provider's side, one per kind. */
function providerPages(capability: IntegrationCapabilityReadiness): { label: string; url: string }[] {
  const pages = new Map<string, { label: string; url: string }>();
  for (const { destination } of capability.recovery) {
    if (!destination || pages.has(destination.action)) continue;
    if (!isSupportedProviderDestination(capability.capability_id, destination)) continue;
    pages.set(destination.action, { label: destination.label, url: destination.url });
  }
  return [...pages.values()];
}

export function ConnectionsBody({ readiness }: { readiness: CourseIntegrationReadiness }) {
  const copy = FRAME_COPY.connections;
  return (
    <ul className="grid gap-3 text-ui">
      {readiness.capabilities.map((capability) => {
        const provider = FAMILY_OWNER[capability.family] ?? capability.label;
        const ok = isReady(capability);
        return (
          <li key={capability.capability_id} className="grid gap-1">
            <p className="font-medium text-foreground">
              {provider}: {capability.label}
              <span className="ms-2 text-meta font-normal text-muted-foreground">{ok ? copy.status.ready : copy.status[capability.status === "unknown" ? "unknown" : "blocked"]}</span>
            </p>
            {/* What's missing, once, in the person's words; the provider's own page when the fix is there (C4). */}
            {!ok && <p className="text-muted-foreground">{copy.missing(capability.recovery[0]?.code, provider)}</p>}
            {!ok &&
              providerPages(capability).map((page) => (
                <a key={page.url} data-act="leave" href={page.url} target="_blank" rel="noopener noreferrer" className="text-ui font-semibold text-primary hover:underline">
                  {page.label}
                  <span className="sr-only"> (opens in a new tab)</span>
                </a>
              ))}
          </li>
        );
      })}
    </ul>
  );
}
